import React, { useEffect, useState, useContext } from 'react';
import get from 'lodash/get';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import AddIcon from '@wix/da-ds/pkg/Icons/16x16/Add';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import CollectionsList from '../../../CollectionPanel/CollectionList';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DSModal, { MODAL_FOOTER_BUTTON_SIZE, } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import DSPopover, { POPOVER_FOOTER_BUTTON_SIZE, } from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import NewCollectionPopup from './NewCollectionPopup';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import s from './AddToCollectionPopup.scss';
var AddToCollectionPopup = function (_a) {
    var collectibleDeviation = _a.collectibleDeviation, deviationId = _a.collectibleDeviation.deviationId, className = _a.className, isInitialized = _a.isInitialized, hasMoreCollections = _a.hasMoreCollections, collectionsCount = _a.collectionsCount, ignorePreselectedCollections = _a.ignorePreselectedCollections, notificationQueue = _a.notificationQueue, selectedFolderIds = _a.selectedFolderIds, initializeCollectionsForDeviation = _a.initializeCollectionsForDeviation, commitCollections = _a.commitCollections, removeQueues = _a.removeQueues, onClose = _a.onClose;
    var t = useTranslation().t;
    useEffect(function () {
        if (!isInitialized) {
            var noPreselectedFeatured = true;
            initializeCollectionsForDeviation(deviationId, get(collectibleDeviation, 'stats.favourites', 0), noPreselectedFeatured, ignorePreselectedCollections);
        }
    }, [
        isInitialized,
        initializeCollectionsForDeviation,
        deviationId,
        collectibleDeviation,
        ignorePreselectedCollections,
    ]);
    // flush everything from a given (via props) notificationQueue on init
    // so that on save the new notification doesn't overlap with any old ones
    useEffect(function () {
        removeQueues(function (name) { return name === notificationQueue; });
    }, [notificationQueue, removeQueues]);
    var isMobile = useContext(MobileContext);
    var _b = useState(''), filterValue = _b[0], setFilterValue = _b[1];
    var _c = useState(false), showingNewCollectionPopup = _c[0], setShowNewCollectionPopup = _c[1];
    var onFilterInputChange = function (e) { return setFilterValue(e.target.value); };
    var onDone = function () {
        commitCollections(collectibleDeviation, notificationQueue || 'default');
        onClose();
    };
    if (showingNewCollectionPopup) {
        return (React.createElement(NewCollectionPopup, { className: className, collectibleDeviation: collectibleDeviation, onClose: function () { return setShowNewCollectionPopup(false); } }));
    }
    var author = collectibleDeviation.author;
    var filterInput = !hasMoreCollections && collectionsCount >= 5 ? (React.createElement(TextInput, { id: "search-input", className: s['filter-input'], biData: BiData({
            evid: 2,
            click_info: 'addToCollectionPopover.filterInput',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
        }), label: t('addToCollectionPopover.input.filter.placeholder'), placeholder: t('addToCollectionPopover.input.filter.placeholder'), value: filterValue, onChange: onFilterInputChange, prefix: React.createElement(SearchIcon, { disableDefaultColors: true }), noBottomSpacing: true, isLabelHidden: true })) : undefined;
    var doneButton = (React.createElement(SolidButton, { variant: "approval-green", biData: {
            evid: BiEventType.ADD_TO_COLLECTION_DONE_CLICK,
            creatorid: author && author.useridUuid,
            typeid: getDeviationResourceType(collectibleDeviation),
            itemid: deviationId,
            sectionname: undefined,
            collectionid: selectedFolderIds.length > 1 ? undefined : selectedFolderIds[0],
            num_collections: selectedFolderIds.length,
        }, onClick: onDone, size: isMobile ? MODAL_FOOTER_BUTTON_SIZE : POPOVER_FOOTER_BUTTON_SIZE }, t('common.done')));
    var newCollectionButton = (React.createElement(TextButton, { onClick: function () { return setShowNewCollectionPopup(true); }, icon: AddIcon, size: "small", variant: "main", biData: BiData({
            evid: 2,
            click_info: 'addToCollectionPopover.newCollection',
            sectionname: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
            typeid: BiContextProvidedValue,
            itemid: BiContextProvidedValue,
        }) }, t('addToCollectionPopover.button.newCollection')));
    if (isMobile) {
        return (React.createElement(DSModal, { isOpen: true, heading: t('addToCollectionPopover.title'), className: className, contentClassName: s['content-wrapper'], showHeaderBorder: true, showFooterBorder: true, footerRight: [doneButton], footerLeft: [newCollectionButton], withScrollableContentWrapper: false, onRequestClose: onClose },
            filterInput,
            React.createElement(CollectionsList, { collectibleDeviation: collectibleDeviation, filterValue: filterValue })));
    }
    return (React.createElement(DSPopover, { heading: t('addToCollectionPopover.title'), className: c(s['popover-root'], className), contentClassName: s['content-wrapper'], showFooterBorder: true, footerRight: doneButton, footerLeft: newCollectionButton, onCloseClick: onClose, content: React.createElement(React.Fragment, null,
            filterInput,
            React.createElement(CollectionsList, { collectibleDeviation: collectibleDeviation, filterValue: filterValue })) }));
};
AddToCollectionPopup.displayName = 'AddToCollectionPopup';
export default AddToCollectionPopup;
//# sourceMappingURL=AddToCollectionPopup.js.map